// src/Pages/NotFound.jsx
import React from "react";
import { Link } from "react-router-dom";
import './notFound.css';

const NotFound = () => (
  <div className="notfound-container">
    <div className="notfound-content">
      <h1>404</h1>
      <p>Página no encontrada</p>
      <Link to="/" className="btn-back">
        Volver al inicio
      </Link>
    </div>
  </div>
);

export default NotFound;
